import * as Msal from 'msal';
import { db } from '../main';

export default class AuthService {

  /**
   * Callback method from sign-in: if no errors, call callGraphApi() to show results.
   * @param {string} errorDesc - If error occur, the error message
   * @param {object} token - The token received from login
   * @param {object} error - The error string
   * @param {string} tokenType - The token type: For loginRedirect, tokenType = "id_token". For acquireTokenRedirect, tokenType:"access_token".
   */
  loginCallback(errorDesc, token, error, tokenType) {
    console.log("loginCallback");
    if (errorDesc) {
      this.showError(msal.authority, error, errorDesc);
    } else {
      // debugger;
      // this.app.getUserInformation();
    }
  };

  /**
   * Show an error message in the page
   * @param {string} endpoint - the endpoint used for the error message
   * @param {string} error - Error string
   * @param {string} errorDesc - Error description
   */
  showError(endpoint, error, errorDesc) {
    var formattedError = JSON.stringify(error, null, 4);
    if (formattedError.length < 3) {
      formattedError = error;
    }
    document.getElementById("errorMessage").innerHTML = "An error has occurred:<br/>Endpoint: " + endpoint + "<br/>Error: " + formattedError + "<br/>" + errorDesc;
    console.error(error);
  };


  constructor() {
    // let PROD_REDIRECT_URI = '//Still to be determined';
    let redirectUri = window.location.origin;
    // if (window.location.hostname !== '127.0.0.1') {
    //   redirectUri = PROD_REDIRECT_URI;
    // }
    console.log('window.location.origin => ' + window.location.origin);
    this.applicationConfig = {
      clientID: 'fc88ccc2-3898-490b-b7b3-307acec2ba09',
      graphScopes: ['user.read']
    };

    if (window.location.href === 'http://localhost:8080') {
      this.applicationConfig.clientID = '1994a314-2501-4e64-93a7-b22f0b63079e';
    }

    this.app = new Msal.UserAgentApplication(
      this.applicationConfig.clientID,
      '',
      this.loginCallback, {
        redirectUri: redirectUri,
        cacheLocation: 'localStorage' 
      }
    );
  };


  /**
   * Call the Microsoft Graph API and display the results on the page. Sign the user in if necessary
   */
  getUserInformation() {
    // console.log("getUserInformation");
    
    var user = this.app.getUser();
    if (!user) {
      // If user is not signed in, then prompt user to sign in via loginRedirect.
      // This will redirect user to the Azure Active Directory v2 Endpoint
      this.app.loginRedirect(this.applicationConfig.graphScopes);
      // The call to loginRedirect above frontloads the consent to query Graph API during the sign-in.
      // If you want to use dynamic consent, just remove the graphAPIScopes from loginRedirect call.
      // As such, user will be prompted to give consent when requested access to a resource that 
      // he/she hasn't consented before. In the case of this application - 
      // the first time the Graph API call to obtain user's profile is executed.
    } else {

    // console.log(this.app.getPhoto());
      

      // // If user is already signed in, display the user info
      // var userInfoElement = document.getElementById("userInfo");
      // userInfoElement.parentElement.classList.remove("hidden");
      // userInfoElement.innerHTML = JSON.stringify(user, null, 4);

      // // Show Sign-Out button
      // document.getElementById("signOutButton").classList.remove("hidden");

      // // Now Call Graph API to show the user profile information:
      // var graphCallResponseElement = document.getElementById("graphResponse");
      // graphCallResponseElement.parentElement.classList.remove("hidden");
      // graphCallResponseElement.innerText = "Calling Graph ...";

      // // In order to call the Graph API, an access token needs to be acquired.
      // // Try to acquire the token used to query Graph API silently first:
      // this.app.acquireTokenSilent(graphAPIScopes)
      //   .then(function (token) {
      //     //After the access token is acquired, call the Web API, sending the acquired token
      //     callWebApiWithToken(graphApiEndpoint, token, graphCallResponseElement, document.getElementById("accessToken"));

      //   }, function (error) {
      //     // If the acquireTokenSilent() method fails, then acquire the token interactively via acquireTokenRedirect().
      //     // In this case, the browser will redirect user back to the Azure Active Directory v2 Endpoint so the user 
      //     // can reenter the current username/ password and/ or give consent to new permissions your application is requesting.
      //     // After authentication/ authorization completes, this page will be reloaded again and callGraphApi() will be executed on page load.
      //     // Then, acquireTokenSilent will then get the token silently, the Graph API call results will be made and results will be displayed in the page.
      //     if (error) {
      //       this.app.acquireTokenRedirect(graphAPIScopes);
      //     }
      //   });
    }
    // axios.post( + user.displayableId + '.json' ).then() {

    // }.cat

    // db.collection('people').add(JSON.stringify(user));
    // console.log(user);
    var docRef = db.collection('people').doc(user.name)
    docRef.get().then(function(doc) {
      if (doc.exists) {
      } else {
          docRef.set({displayableId: user.displayableId, name: user.name, identityProvider: user.identityProvider, userIdentifier: user.userIdentifier});
      }
    }).catch(function(error) {
        // console.log("Error getting document:", error);
    });
    return user;
  }


  login() {
    return this.app.loginRedirect(this.applicationConfig.graphScopes);
  };
  logout() {
    this.app.logout();
  };
  getToken() {
    return this.app.acquireTokenSilent(this.applicationConfig.graphScopes).then(
      accessToken => {
        return accessToken;
      },
      error => {
        return this.app
          .acquireTokenPopup(this.applicationConfig.graphScopes)
          .then(
            accessToken => {
              return accessToken;
            },
            err => {
              console.error(err);
            }
          );
      }
    );
  };
}



// WEBPACK FOOTER //
// ./src/services/auth.service.js